require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-reminder-to-all-current-visa-credit-card-holders.json") })
        }
      }, "path---articles-reminder-to-all-current-visa-credit-card-holders");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-reminder-to-all-current-visa-credit-card-holders!./.cache/json/articles-reminder-to-all-current-visa-credit-card-holders.json
// module id = 1725
// module chunks = 231608221292675